__turbopack_context__.v({
  "closing": "Q0fEIW_closing",
  "contentColumn": "Q0fEIW_contentColumn",
  "headingColumn": "Q0fEIW_headingColumn",
  "intro": "Q0fEIW_intro",
  "pointerIndex": "Q0fEIW_pointerIndex",
  "pointerList": "Q0fEIW_pointerList",
  "pointerRow": "Q0fEIW_pointerRow",
  "pointerTitle": "Q0fEIW_pointerTitle",
  "shell": "Q0fEIW_shell",
});
